import { Fragment, useContext, useState } from "react";
import { PriceContext } from "src/pages/OfferPage/QuotePrices/QuotePrices";
import { formatRowPrice } from "src/pages/OfferPage/QuotePrices/PriceRowUtils";
import { IS_READ_ONLY_USER } from "src/utils/controllerAdapterForOfferPage"

const isValidTaxRateInput = (value: string): boolean => /^\d*[,.]?\d*$/.test(value);

const normalizeTaxRate = (value: string): string => {
  const val = value
    .replace(/^0+(?=\d)/, '')
    .replace(/([,.]\d*?)0+$/, '$1')
    .replace(/[,.]$/, '');
  if (!/^(0|[1-9]\d*)([,.]\d*[1-9])?$/.test(val)) return '0';
  const numeric = Number(val.replace(',', '.'));
  if (numeric > 100) return '100';
  if (numeric < 0) return '0';
  return val;
};

export const GrandTotal = (props: {
  newColumns: any;
  newRows: any;
}) => {

  const context = useContext(PriceContext);
  const onEdit = context.onEditHandler;
  const {
    newColumns,
    newRows,
  } = props;

  const [taxRateValue, setTaxRateValue] = useState<string>(() => {
    return normalizeTaxRate(newRows[1].tax_rate?.toString() ?? '0');
  }); // Assuming tax rate is at index 1
  const currency = context.currency;
  const editKey = "globalTax";

  return (
    <table
      className="table table-striped table-hover order-column lightershadow no-footer table-grand-total"
      style={{
       width: "100%",
       marginTop: "20px",
       borderSpacing: 0
    }}
    >
      <colgroup>
        {newColumns.map((col: any) => (
          <col
            key={col.data}
            width={
              col.width
                ? typeof col.width === "number"
                  ? `${col.width}px`
                  : col.width
                : "auto"
            }
          />
        ))}
      </colgroup>
      <thead>
        <tr>
          {newColumns.map((col: any) => (
            <th style={{ width: col.width, padding: "8px 15px", verticalAlign: "middle" }} key={col.data}>
              {col.data === "total_price" ? (
              <span style={{ float: "right", whiteSpace: "nowrap" }}>
                {col.title}
              </span>
              ): (col.title)}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {newRows.map((row: any, rowIndex: number) => (
            <td
              className={newColumns[rowIndex].numeric ? "numeric-cell" : ""}
              style={{ padding: "8px 15px" }}
              key={newColumns[rowIndex].data}
            >
              {newColumns[rowIndex].data === "tax_rate" ? (
                <Fragment>
                    <div
                        style={{
                          border: "1px solid #b9b9b9",
                          display: "flex",
                          justifyContent: "center",
                        }}
                        className="remove-on-export"
                    >
                      <input
                          style={{
                            width: 50,
                            height: 24,
                            border: "none",
                            textAlign: "center",
                            fontSize: 15,
                          }}
                          className={
                            IS_READ_ONLY_USER
                                ? "number-spin quote-footer-pcnt-input disable"
                                : "number-spin quote-footer-pcnt-input"
                          }
                          type="text"
                          inputMode="decimal"
                          value={taxRateValue}
                          onChange={(e) => {
                            if (isValidTaxRateInput(e.target.value)) setTaxRateValue(e.target.value);
                          }}
                          onBlur={(e) => {
                            const normalized = normalizeTaxRate(e.target.value);
                            setTaxRateValue(normalized);
                            onEdit(editKey, normalized.replace(',', '.'));
                          }}
                          onFocus={(e) => e.target.select()}
                      />
                      <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "0px 5px",
                            backgroundColor: "transparent",
                            fontSize: 15,
                          }}
                      >
                        %
                      </div>
                    </div>

                </Fragment>
              ) : newColumns[rowIndex].data === "total_price" ? (
                  <span style={{ float: "right", whiteSpace: "nowrap" }}>
                    {formatRowPrice(row[newColumns[rowIndex].data], currency)}
                  </span>
              ) : (
                  <span style={{ whiteSpace: "nowrap" }}>
                    {formatRowPrice(row[newColumns[rowIndex].data], currency)}
                  </span>
              )}
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
};
